  <mat-card id="cadastro">
    <mat-card-header>
      <div fxLayout="row">
        <div>
          <h3>Cadastro do Solicitação</h3>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>

      <h4>ATENÇÃO:
        <br>1- Sua solicitação só poderá ser gravada com Todos os Campos preenchidos
        <br>2- Os arquivos para Upload só poderão ser do tipo PDF
      </h4>

      <form [formGroup]="form"  class="formulario">

        <input  hidden="true" matInput formControlName="classificacao" >
        <input  hidden="true" matInput formControlName="codturma" >
        <input hidden="true"  matInput formControlName="Curso" >

        <div class="form_linha" fxLayout.xs="column">
             <h3>Curso: {{mcurso}}</h3>
        </div>

        <div class="form_linha" fxLayout.xs="column" class="titupload">
          <h4>
            Identificação
          </h4>
        </div>


        <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="nome campo_flex tamanho_70">
              <mat-label>Nome:</mat-label>
              <input matInput formControlName="nome"  >
              <mat-error *ngIf="formControls.nome.invalid">Por favor preencha o seu nome.</mat-error>
            </mat-form-field>

            <mat-form-field class="cpf  campo_flex tamanho_30">
              <mat-label>CPF:</mat-label>
              <input matInput formControlName="cpf" mask="000.000.000-99" >
            </mat-form-field>

          </div>


          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="nome campo_flex tamanho_70">
              <mat-label>Nome_Civil:</mat-label>
              <input matInput formControlName="nome_civil"  >
              <mat-error *ngIf="formControls.nome.invalid">Por favor preencha o seu nome.</mat-error>
            </mat-form-field>

            <mat-form-field class="genero campo_flex tamanho_25">
              <mat-label>Genero</mat-label>
              <mat-select name="genero" formControlName="genero">
                <mat-optgroup label="Genero">
                  <mat-option value="Homem Cisgênero" >Homem Cisgênero</mat-option>
                  <mat-option value="Mulher Cisgênero">Mulher Cisgênero</mat-option>
                  <mat-option value="Mulher Trans" >Mulher Trans</mat-option>
                  <mat-option value="Homem Trans">Homem Trans</mat-option>
                  <mat-option value="Travesti" >Travesti</mat-option>
                  <mat-option value="Pessoa Trans não Binária">Pessoa Trans não Binária</mat-option>
                  <mat-option value="Pessoa Intersexo">Pessoa Intersexo</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>



          </div>




          <div class="form_linha" fxLayout.xs="column">
            <mat-form-field class="identidade  campo_flex tamanho_33">
              <mat-label>Nº Identidade:</mat-label>
              <input matInput formControlName="identidade"  >
            </mat-form-field>
            <mat-form-field class="orgaoid  campo_flex tamanho_33">
              <mat-label>Orgão Identidade:</mat-label>
              <input matInput formControlName="orgaoid"  >
            </mat-form-field>
            <mat-form-field class="dtid  campo_flex tamanho_33">
              <mat-label>Dt Exp Identidade:</mat-label>
              <input matInput formControlName="dtid" mask="00/00/0000" >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">


            <mat-form-field class="Nasc campo_flex tamanho_25">
              <mat-label>Dt Nascimento:</mat-label>
              <input matInput formControlName="Nasc" mask="00/00/0000" >
            </mat-form-field>


            <mat-form-field class="sexo campo_flex tamanho_25">
              <mat-label>Sexo</mat-label>
              <mat-select name="sexo" formControlName="IdSexo">
                <mat-optgroup label="Sexo">
                  <mat-option value="1" >Masculino</mat-option>
                  <mat-option value="0">Feminino</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="nacionalidade campo_flex tamanho_25">
              <mat-label>Nacionalidade:</mat-label>
              <input matInput formControlName="nacionalidade"  >
            </mat-form-field>

            <mat-form-field class="naturalidade campo_flex tamanho_25">
              <mat-label>Naturalidade:</mat-label>
              <input matInput formControlName="naturalidade"  >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="est_civil campo_flex tamanho_33">
              <mat-label>Estado Civil</mat-label>
              <mat-select name="est_civil" formControlName="est_civil">
                <mat-optgroup label="Est Civil">
                  <mat-option value="Solteiro(a)">Solteiro(a)</mat-option>
                  <mat-option value="Casado(a)">Casado(a)</mat-option>
                  <mat-option value="Separado(a)">Separado(a)</mat-option>
                  <mat-option value="Divorciado(a)">Divorciado(a)</mat-option>
                  <mat-option value="União Estável">União Estável</mat-option>
                  <mat-option value="Viúvo(a)">Viúvo(a)</mat-option>

                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="passaporte campo_flex tamanho_33">
              <mat-label>Passaporte:</mat-label>
              <input matInput formControlName="passaporte"  >
            </mat-form-field>

            <mat-form-field class="Expedicao campo_flex tamanho_33">
              <mat-label>Dt Expedição:</mat-label>
              <input matInput formControlName="dt_exp_passaporte" mask="00/00/0000" >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">


            <mat-form-field class="pai campo_flex tamanho_50">
              <mat-label>Pai:</mat-label>
              <input matInput formControlName="pai" >
            </mat-form-field>



            <mat-form-field class="mae campo_flex tamanho_50">
              <mat-label>Mãe:</mat-label>
              <input matInput formControlName="mae"  >
            </mat-form-field>



          </div>



          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="Numtitulo campo_flex tamanho_25">
              <mat-label>Titulo Eleitoral:</mat-label>
              <input matInput formControlName="Numtitulo"  >
            </mat-form-field>

            <mat-form-field class="Uftitulo campo_flex tamanho_25">
              <mat-label>UF Eleitoral:</mat-label>
              <input matInput formControlName="Uftitulo"  >
            </mat-form-field>

            <mat-form-field class="Zonatitulo campo_flex tamanho_25">
              <mat-label>Zona Eleitoral:</mat-label>
              <input matInput formControlName="Zonatitulo"  >
            </mat-form-field>

            <mat-form-field class="Secaotitulo campo_flex tamanho_25">
              <mat-label>Seção Eleitoral:</mat-label>
              <input matInput formControlName="Secaotitulo"  >
            </mat-form-field>
          </div>



          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="Nummilitar campo_flex tamanho_33">
              <mat-label>Certificado Militar:</mat-label>
              <input matInput formControlName="Nummilitar"  >
            </mat-form-field>

            <mat-form-field class="Orgmilitar campo_flex tamanho_33">
              <mat-label>Orgão Militar:</mat-label>
              <input matInput formControlName="Orgmilitar"  >
            </mat-form-field>

            <mat-form-field class="Seriemilitar campo_flex tamanho_33">
              <mat-label>Seção Militar:</mat-label>
              <input matInput formControlName="Seriemilitar"  >
            </mat-form-field>

          </div>




          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="Etinia campo_flex tamanho_33">
              <mat-label>Cor / Etnia</mat-label>
              <mat-select name="Etinia" formControlName="Etinia">
                <mat-optgroup label="Cor/Etnia">
                  <mat-option value="1">Amarelo</mat-option>
                  <mat-option value="2">Branco</mat-option>
                  <mat-option value="3">Indigena</mat-option>
                  <mat-option value="4">Negra</mat-option>
                  <mat-option value="5">Parda</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="Grupo campo_flex tamanho_33">
              <mat-label>Grupo Sanguineo</mat-label>
              <mat-select name="Grupo" formControlName="Grupo">
                <mat-optgroup label="Grupo Sanguineo">
                  <mat-option value="A">A</mat-option>
                  <mat-option value="B">B</mat-option>
                  <mat-option value="O">O</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="Rh campo_flex tamanho_33">
              <mat-label>Tipo Sanguineo</mat-label>
              <mat-select name="Rh" formControlName="Rh">
                <mat-optgroup label="Tipo Sanguineo">
                  <mat-option value="Positivo">Positivo</mat-option>
                  <mat-option value="Negativo">Negativo</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="conselhos campo_flex tamanho_60">
              <mat-label>Conselho Profissional</mat-label>
              <mat-select name="IdConselho" formControlName="IdConselho">
                <mat-optgroup label="Conselho Profissional">

                  <mat-option value="1">Conselho regional de administração</mat-option>
                  <mat-option value="2">Conselho regional de biblioteconomia</mat-option>
                  <mat-option value="3">Conselho regional de biologia</mat-option>
                  <mat-option value="4">Conselho regional de biomedicina</mat-option>
                  <mat-option value="5">Conselho regional de contabilidade</mat-option>
                  <mat-option value="6">Conselho regional de economia</mat-option>
                  <mat-option value="7">Conselho regional de educação física</mat-option>
                  <mat-option value="8">Conselho regional de enfermagem</mat-option>
                  <mat-option value="9">Conselho regional de engenharia, arquitetura e agronomia</mat-option>
                  <mat-option value="10">Conselho regional de estatística</mat-option>
                  <mat-option value="11">Conselho regional de farmácia</mat-option>
                  <mat-option value="12">Conselho regional de fisioterapia</mat-option>
                  <mat-option value="13">Conselho regional de medicina veterinária</mat-option>
                  <mat-option value="14">Conselho regional de medicina</mat-option>
                  <mat-option value="15">Conselho regional de nutricionistas</mat-option>
                  <mat-option value="16">Conselho regional de odontologia</mat-option>
                  <mat-option value="17">Conselho regional de psicologia</mat-option>
                  <mat-option value="18">Conselho regional de química</mat-option>
                  <mat-option value="19">Conselho regional de serviço social</mat-option>
                  <mat-option value="20">Conselho regional de técnicos em radiologia</mat-option>
                  <mat-option value="21">Ordem dos advogados do brasil</mat-option>
                  <mat-option value="22">Conselho regional de fonoaudiologia</mat-option>

                </mat-optgroup>
              </mat-select>
            </mat-form-field>




            <mat-form-field class="numconselho campo_flex tamanho_20">
              <mat-label>Nº Conselho Prof:</mat-label>
              <input matInput formControlName="numconselho"  >
            </mat-form-field>



            <mat-form-field class="dt_exp_conselho campo_flex tamanho_20">
              <mat-label>Dt Exp Conselho:</mat-label>
              <input matInput formControlName="dt_exp_conselho" mask="00/00/0000" >
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">


  <mat-form-field class="nomeac campo_flex tamanho_70">
    <mat-label>Em Caso de Acidente Comunicar a:</mat-label>
    <input matInput formControlName="nomeac"  >
    <mat-error *ngIf="formControls.nomeac.invalid">Por favor preencha o seu nome a ser avisado.</mat-error>
  </mat-form-field>


  <mat-form-field class="Parentesco campo_flex tamanho_33">
    <mat-label>Parentesco</mat-label>
    <mat-select name="parentesco" formControlName="parentesco">
      <mat-optgroup label="Parentesco">
        <mat-option value="1">Pai</mat-option>
        <mat-option value="2">Mãe</mat-option>
        <mat-option value="3">Filho(a)</mat-option>
        <mat-option value="4">Avô/Avó</mat-option>
        <mat-option value="5">Irmão(a)</mat-option>
        <mat-option value="6">Cunhado(a)</mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="Telac campo_flex tamanho_25">
    <mat-label>Tel/Celular:</mat-label>
    <input matInput formControlName="telac" mask="(00)0000-00000" >
  </mat-form-field>

</div>
          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              Localização
            </h4>
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="cep campo_flex tamanho_20">
              <mat-label>CEP:</mat-label>
              <input matInput formControlName="cep" mask="00000000" (blur)="consultacep()" >

            </mat-form-field>

            <mat-form-field class="endereco campo_flex tamanho_70">
              <mat-label>Endereço:</mat-label>
              <input matInput formControlName="endereco"  >
            </mat-form-field>

            <mat-form-field class="numero campo_flex tamanho_5">
              <mat-label>Numero:</mat-label>
              <input matInput formControlName="numero"  >
            </mat-form-field>


            <mat-form-field class="complemento campo_flex tamanho_5">
              <mat-label>Complemento:</mat-label>
              <input matInput formControlName="complemento"  >
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="bairro campo_flex tamanho_40">
              <mat-label >Bairro:</mat-label>
              <input matInput formControlName="bairro"  >
            </mat-form-field>




            <mat-form-field class="cidade campo_flex tamanho_40">
              <mat-label>Cidade:</mat-label>
              <input matInput formControlName="cidade"  >
            </mat-form-field>



            <mat-form-field class="uf campo_flex tamanho_20">
              <mat-label>UF:</mat-label>
              <input matInput formControlName="uf"  >
            </mat-form-field>

          </div>



          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="fixo campo_flex tamanho_25">
              <mat-label>Tel Fixo:</mat-label>
              <input matInput formControlName="fixo" mask="(00)0000-0000" >
            </mat-form-field>



            <mat-form-field class="celular campo_flex tamanho_25">
              <mat-label>Celular:</mat-label>
              <input matInput formControlName="celular" mask="(00)0000-00000" >
            </mat-form-field>



            <mat-form-field class="email campo_flex tamanho_50">
              <mat-label>E-mail:</mat-label>
              <input matInput formControlName="email"  >
            </mat-form-field>



          </div>


          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              Dados Bancários
            </h4>
          </div>

          <div class="form_linha" fxLayout.xs="column">


            <mat-form-field class="banco campo_flex tamanho_33">
              <mat-label>Banco</mat-label>
              <mat-select name="banco" formControlName="banco">
                <mat-optgroup label="Banco">
                  <mat-option value="">Escolha Banco</mat-option>
                  <mat-option value="25">Banco Alfa S.A.</mat-option>
                  <mat-option value="318">Banco BMG S.A.</mat-option>
                  <mat-option value="237">Banco Bradesco S.A.</mat-option>
                  <mat-option value="208">Banco BTG Pactual S.A.</mat-option>
                  <mat-option value="336">Banco C6 Bank S.A.</mat-option>
                  <mat-option value="745">Banco Citibank S.A.</mat-option>
                  <mat-option value="229">Banco Cruzeiro do Sul S.A.</mat-option>
                  <mat-option value="003">Banco da Amazônia S.A.</mat-option>
                  <mat-option value="1">Banco do Brasil S.A.</mat-option>
                  <mat-option value="341">Banco Itaú Unibanco S.A.</mat-option>
                  <mat-option value="260">Banco Nubank S.A.</mat-option>
                  <mat-option value="623">Banco Panamericano S.A.</mat-option>
                  <mat-option value="33">Banco Santander S.A.</mat-option>
                  <mat-option value="136">Banco Unicred S.A.</mat-option>
                  <mat-option value="104">Caixa Econômica Federal</mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>



            <mat-form-field class="agencia campo_flex tamanho_33">
              <mat-label>Agencia:</mat-label>
              <input matInput formControlName="agencia"  >
            </mat-form-field>



            <mat-form-field class="Aconta campo_flex tamanho_33">
              <mat-label>Conta Corrente:</mat-label>
              <input matInput formControlName="Aconta"  >
            </mat-form-field>



          </div>


          <div class="form_linha" fxLayout.xs="column" >
            <mat-form-field class="status campo_flex tamanho_100" >
              <input matInput formControlName="status" readonly >
            </mat-form-field>
          </div>


          <div class="form_linha" fxLayout.xs="column">
          <hr>

          </div>




          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              UPLOAD DE DOCUMENTOS
              <br>Atenção:
              <br>1- Os arquivos para Upload só poderão ser do tipo PDF
              <br>2- Use 1(hum) arquivo por documento (frente e verso no mesmo arquivo)
              <br>3- Arquivos grafados em <font color="#FF0000" size="2" face="Verdana, Arial, Helvetica, sans-serif"><strong><em>Vermelho</em></strong></font> são obrigatórios
            </h4>
          </div>
          <div class="form_linha" fxLayout.xs="column">

            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >1- IDENTIDADE </font></div>

              <div class="campo_flex tamanho_50" >



                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename1}}" target="_blank">{{m_filename1}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('1',caminhoArquivosUpload,m_filename1)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('1',caminhoArquivosUpload,m_filename1)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >2- CPF </font></div>

              <div class="campo_flex tamanho_50" >


                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename2}}" target="_blank">{{m_filename2}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('2',caminhoArquivosUpload,m_filename2)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('2',caminhoArquivosUpload,m_filename2)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">3- PIS</div>

              <div class="campo_flex tamanho_50" >


                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename3}}" target="_blank">{{m_filename3}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('3',caminhoArquivosUpload,m_filename3)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('3',caminhoArquivosUpload,m_filename3)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>


          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">4- COMP. RESIDÊNCIA </div>

              <div class="campo_flex tamanho_50" >

                 <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename4}}" target="_blank">{{m_filename4}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('4',caminhoArquivosUpload,m_filename4)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('4',caminhoArquivosUpload,m_filename4)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">5- LIBERAÇÃO/QUITAÇÃO SERV. MILITAR</div>

              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename5}}" target="_blank">{{m_filename5}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('5',caminhoArquivosUpload,m_filename5)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('5',caminhoArquivosUpload,m_filename5)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>


          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">6- CONSELHO REGIONAL</div>

              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename6}}" target="_blank">{{m_filename6}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('6',caminhoArquivosUpload,m_filename6)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('6',caminhoArquivosUpload,m_filename6)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">7- TRANSFERENCIA CONSELHO REGIONAL</div>

              <div class="campo_flex tamanho_50" >

                 <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename7}}" target="_blank">{{m_filename7}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('7',caminhoArquivosUpload,m_filename7)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('7',caminhoArquivosUpload,m_filename7)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>


          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >8- HISTÓRICO </font></div>

              <div class="campo_flex tamanho_50" >

                 <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename8}}" target="_blank">{{m_filename8}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('8',caminhoArquivosUpload,m_filename8)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('8',caminhoArquivosUpload,m_filename8)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">9- COMP. EXPERIÊNCIA PROFISSIONAL</div>

              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename9}}" target="_blank">{{m_filename9}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('9',caminhoArquivosUpload,m_filename9)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('9',caminhoArquivosUpload,m_filename9)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>



          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >10- CERT/CERTIDÃO DE CONCLUSÃO </font></div>

              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename50}}" target="_blank">{{m_filename50}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('50',caminhoArquivosUpload,m_filename50)"><mat-icon>upload</mat-icon></button>
              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('50',caminhoArquivosUpload,m_filename50)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">11- INSCRIÇÃO INSS</div>

              <div class="campo_flex tamanho_50" >


                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename51}}" target="_blank">{{m_filename51}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('51',caminhoArquivosUpload,m_filename51)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('51',caminhoArquivosUpload,m_filename51)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25"> <font color="#FF0000" size="4" >12- QUITAÇÃO ELEITORAL </font> </div>

              <div class="campo_flex tamanho_50" >


                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename52}}" target="_blank">{{m_filename52}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('52',caminhoArquivosUpload,m_filename52)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('52',caminhoArquivosUpload,m_filename52)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">13- CTPS</div>

              <div class="campo_flex tamanho_50" >

                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename53}}" target="_blank">{{m_filename53}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('53',caminhoArquivosUpload,m_filename53)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('53',caminhoArquivosUpload,m_filename53)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <section class="campo_flex tamanho_100 flex_wrap">
              <div class="campo_flex tamanho_25">14- COMPROVANTE SEG DE VIDA</div>

              <div class="campo_flex tamanho_50" >
                <a href="{{caminhoArquivosUpload}}{{cpf}}/{{m_filename54}}" target="_blank">{{m_filename54}}</a>
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('54',caminhoArquivosUpload,m_filename54)"><mat-icon>upload</mat-icon></button>

              </div>
              <div class="campo_flex tamanho_25" >
                <button mat-mini-fab color="primary" class="upload-btn" (click)="fileDelete('54',caminhoArquivosUpload,m_filename54)"><mat-icon>delete</mat-icon></button>
              </div>

            </section>
          </div>

          <div class="form_linha" fxLayout.xs="column">
            <hr>
          </div>


          <div class="form_linha botoes">

            <button type="button" mat-raised-button name="retorna" color="warn" (click)="retorna()" >
              Retorna
            </button>

            <button type="button" mat-raised-button name="solicita" color="primary" (click)="enviarInscricao()" >
                 Confirmar Operação
            </button>

          </div>



      </form>

    </mat-card-content>

  </mat-card>
